import {DefaultTheme} from "styled-components";

import {theme} from "@/GlobalStyle";

/**
 * Affiche un toast en bas de la page avec le texte fourni
 * @param text - Le texte à afficher dans le toast
 * @param duration - Durée d'affichage en millisecondes (par défaut: 3000ms)
 */
export default function toast(
  text: string,
  duration: number = 3000,
  color: keyof DefaultTheme["colors"]
): void {
  // Créer le conteneur de toast s'il n'existe pas
  let toastContainer = document.getElementById("toast-container");

  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    toastContainer.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: center;
      pointer-events: none;
    `;
    document.body.appendChild(toastContainer);
  }

  // Créer l'élément toast
  const toastElement = document.createElement("div");
  toastElement.style.cssText = `
    background-color: ${color ? theme.colors[color] : theme.colors.darkPrimary};
    color: ${theme.colors.white};
    padding: 12px 24px;
    border-radius: 4px;
    box-shadow: 0 4px 6px ${theme.colors.shadow};
    font-family: 'Quicksand', sans-serif;
    font-weight: 500;
    font-size: 0.875rem;
    white-space: nowrap;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: auto;
    max-width: 90vw;
    word-wrap: break-word;
    white-space: normal;
    text-align: center;
  `;
  toastElement.textContent = text;

  // Ajouter le toast au conteneur
  toastContainer.appendChild(toastElement);

  // Animation d'entrée
  requestAnimationFrame(() => {
    toastElement.style.opacity = "1";
    toastElement.style.transform = "translateY(0)";
  });

  // Supprimer le toast après la durée spécifiée
  setTimeout(() => {
    toastElement.style.opacity = "0";
    toastElement.style.transform = "translateY(20px)";
    setTimeout(() => {
      if (toastElement.parentNode) {
        toastElement.parentNode.removeChild(toastElement);
      }
      // Supprimer le conteneur s'il est vide
      if (toastContainer && toastContainer.children.length === 0) {
        if (toastContainer.parentNode) {
          toastContainer.parentNode.removeChild(toastContainer);
        }
      }
    }, 300); // Attendre la fin de l'animation de sortie
  }, duration);
}
